<template>
  <c-card>
    <template slot="title">
      {{ name }}
      <el-rate
        v-if="rating"
        class="rating"
        :value="rating"
        disabled
        show-score
      />
    </template>

    <div slot="header">
      <c-button-link
        v-if="$is([$config.groups.COACHEE])"
        :to="{
          name: 'coach-invitation',
          params: { id }
        }"
        round
        type="primary"
      >
        Zum Coaching einladen
      </c-button-link>

      <c-button-link
        :to="{
          name: 'coach-detail',
          params: { id }
        }"
        round
      >
        Details
      </c-button-link>
    </div>
  </c-card>
</template>

<script>
import CButtonLink from '@/components/CButtonLink'
import CCard from '@/components/CCard'

export default {
  name: 'CCoachCard',

  components: {
    CButtonLink,
    CCard
  },

  props: {
    id: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    rating: {
      type: Number
    }
  }
}
</script>

<style lang="scss" scoped>
.rating {
  margin-left: 0.5em;
  vertical-align: 0.15em;
}
</style>
